import { Box, useTheme } from '@mui/material';
import {
  DataGridPro as MuiDataGridPro,
  DataGridProProps,
} from '@mui/x-data-grid-pro';

const DataGridPro = (props: DataGridProProps) => {
  const theme = useTheme();
  const tableContainerStyles = {
    minHeight: 678,
    width: '100%',
    paddingTop: '8px',
  };

  const tableStyles = {
    fontFamily: 'Source Sans Pro',
    border: 'none',
    '& .MuiDataGrid-cell': {
      fontFamily: 'Source Sans Pro',
      borderBottom: `1px solid ${theme.palette.lightDividerColor.main}`,
      borderRight: 'none',
      borderLeft: 'none',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20.02px',
      letterSpacing: '0.17px',
      padding: 0,
    },
    '& .MuiDataGrid-columnHeaders': {
      fontFamily: 'Source Sans Pro',
      fontSize: '14px',
      borderBottom: `1px solid ${theme.palette.lightDividerColor.main}`,
      borderTop: 'none',
      borderRight: 'none',
      borderLeft: 'none',
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader': {
      outline: 'none !important',
      '&:focus': {
        outline: 'none !important',
      },
      '&:focus-within': {
        outline: 'none !important',
      },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontFamily: 'Source Sans Pro',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: '0.17px',
      textAlign: 'left',
      textUnderlinePosition: 'from-font',
      textDecorationSkipInk: 'none',
      color: theme.palette.lightTextPrimary.main,
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: theme.palette.lightBackgroundPaperHover.main,
    },
    '& .MuiDataGrid-row.escalated-row .CellDualValue-primaryValue, & .MuiDataGrid-row.escalated-row .CellDualValue-secondaryValue':
      {
        color: `${theme.palette.error.main} !important`,
      },
    '& .MuiDataGrid-main': {
      borderRadius: 0,
    },
    '& .MuiDataGrid-footerContainer': {
      fontFamily: 'Source Sans Pro',
      fontSize: '12px',
      '& .MuiTablePagination-root': {
        fontSize: '12px',
        color: theme.palette.lightTextPrimary.main,
        '& .MuiTablePagination-displayedRows': {
          color: theme.palette.lightTextPrimary.main,
        },
      },
      '& .MuiTablePagination-selectLabel': {
        fontFamily: 'Source Sans Pro',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '19.92px',
        letterSpacing: '0.4px',
        textAlign: 'left',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
        color: theme.palette.lightActionDisabled60p.main,
        margin: 0,
        padding: 0,
      },
      '& .MuiTablePagination-displayedRows': {
        fontFamily: 'Source Sans Pro',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '19.92px',
        letterSpacing: '0.4px',
        textAlign: 'left',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
        color: theme.palette.lightTextPrimary.main,
      },
      '& .MuiTablePagination-select': {
        fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '19px',
        letterSpacing: '0.4px',
        textAlign: 'left',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
        color: theme.palette.lightTextPrimary.main,
      },
      '& .MuiTablePagination-menuItem': {
        fontSize: '172px',
      },
      '& .MuiTablePagination-actions': {
        '& .MuiIconButton-root': {
          color: theme.palette.lightActionDisabled54p.main,
          '&.Mui-disabled': {
            color: theme.palette.lightActionDisabled54p.main,
          },
        },
      },
    },
  };

  return (
    <Box sx={tableContainerStyles}>
      <MuiDataGridPro
        {...props}
        sx={tableStyles}
        disableColumnSelector={props.disableColumnSelector ?? true}
        disableColumnResize={props.disableColumnResize ?? true}
        disableColumnReorder={props.disableColumnReorder ?? true}
        disableColumnMenu={props.disableColumnMenu ?? true}
      />
    </Box>
  );
};

export { DataGridPro };
export type { DataGridProProps };
